/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_None_SelectedInputs */

const en_orders_none_selected = /** @type {(inputs: Orders_None_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No orders selected`)
};

const es_orders_none_selected = /** @type {(inputs: Orders_None_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay pedidos seleccionados`)
};

/**
* | output |
* | --- |
* | "No orders selected" |
*
* @param {Orders_None_SelectedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_none_selected = /** @type {((inputs?: Orders_None_SelectedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_None_SelectedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_none_selected(inputs)
	return es_orders_none_selected(inputs)
});